import { AppState } from "features";
import { createSelector } from "reselect";

const getMenuItems = ({ menuItems: { list } }: AppState) => (list.status === "loaded" ? list.data : null);

export const getMenuItemsSearchOptions = createSelector(getMenuItems, (items) =>
    items ? items.map((item) => ({ displayName: item.displayName, internalName: item.internalName, id: item.id })) : []
);
